/* POKELAGERET homepage singles module (sections/pkl-home-singles.liquid)
   - search: opens the in-stock Single kort collection with the query
   - popular-search pills
   - live in-stock count (Globo's init payload, cached per session; shared key with the collection hero)
   - fan of three random in-stock Pokémon cards (random page of the collection's products.json)
   - product rows: fetch the collection grid section (theme's own product cards) with sort/tag,
     drop sold-out cards, show N; random rows pick a random page and can be reshuffled */
(function () {
  var root = document.querySelector('[data-pkl-home]');
  if (!root) return;

  var colUrl = root.getAttribute('data-collection-url') || '/collections/single-kort';
  var colHandle = root.getAttribute('data-collection-handle') || 'single-kort';
  var colCount = parseInt(root.getAttribute('data-collection-count'), 10) || 0;
  var gridSection = root.getAttribute('data-grid-section') || '';
  var nb = window.Intl && Intl.NumberFormat ? new Intl.NumberFormat('nb-NO') : null;

  /* ---------- search ---------- */
  function openSearch(q) {
    q = String(q || '').trim();
    var u = new URL(colUrl, window.location.origin);
    u.searchParams.set('filter.pa-lager', '1');
    if (q) u.searchParams.set('q', q);
    window.location.assign(u.toString());
  }
  var form = root.querySelector('[data-pkl-home-search]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      var inp = form.querySelector('input[name="q"]');
      openSearch(inp && inp.value);
    });
  }
  var pills = root.querySelectorAll('[data-pkl-home-query]');
  for (var i = 0; i < pills.length; i++) {
    pills[i].addEventListener('click', function (e) { openSearch(e.currentTarget.getAttribute('data-pkl-home-query')); });
  }

  /* ---------- in-stock count ---------- */
  var STOCK_KEY = 'pkl-hero-stock-count-v1', STOCK_TTL = 10 * 60 * 1000;
  var badge = root.querySelector('[data-pkl-stock-count]');
  function setBadge(n) {
    if (!badge || !isFinite(n) || n < 0) return;
    badge.textContent = (nb ? nb.format(n) : String(n)) + ' ' + (badge.getAttribute('data-label') || '');
  }
  function loadCount() {
    try {
      var c = JSON.parse(sessionStorage.getItem(STOCK_KEY));
      if (c && Date.now() - c.t < STOCK_TTL) { setBadge(Number(c.n)); return; }
    } catch (e) {}
    if (!window.fetch) return;
    fetch(colUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pre = doc.querySelector('#gf-filter-preload[href]');
        if (!pre) throw new Error('no preload');
        return fetch(pre.getAttribute('href'), { mode: 'cors', credentials: 'omit' });
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        var filters = Array.isArray(j && j.filters) ? j.filters : [], av = null;
        for (var k = 0; k < filters.length; k++) {
          var f = filters[k];
          if (String(f.attribute || '').toLowerCase() === 'availability' || String(f.handle || '').toLowerCase() === 'pa-lager') { av = f; break; }
        }
        var vals = (av && av.values) || [], n = NaN;
        for (var v = 0; v < vals.length; v++) { if (String(vals[v].value) === '1') { n = parseInt(String(vals[v].count).replace(/\D/g, ''), 10); break; } }
        if (isFinite(n)) { setBadge(n); try { sessionStorage.setItem(STOCK_KEY, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {} }
      })
      .catch(function () {});
  }
  if (badge) loadCount();

  /* ---------- fan of three random cards ---------- */
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function loadFan() {
    var fan = root.querySelector('[data-pkl-fan]');
    if (!fan || !window.fetch) return;
    var perPage = 50, pages = Math.max(1, Math.ceil(colCount / perPage));
    var page = 1 + Math.floor(Math.random() * pages);
    fetch('/collections/' + colHandle + '/products.json?limit=' + perPage + '&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var list = (data && data.products) || [], picks = [], seen = {};
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          var available = (p.variants || []).some(function (v) { return v.available; });
          var img = p.images && p.images[0] && p.images[0].src;
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var isPokemon = tags.some(function (t) { return t.indexOf('pokemon') === 0; }) &&
            !tags.some(function (t) { return t.indexOf('one-piece') === 0 || t.indexOf('magic') === 0; });
          if (!available || !img || !isPokemon || seen[p.handle]) continue;
          seen[p.handle] = 1;
          picks.push({ u: '/products/' + p.handle, i: img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=520', t: p.title });
        }
        shuffle(picks);
        if (picks.length < 3) { fan.remove(); return; }
        var cards = fan.querySelectorAll('.pkl-home__fan-card'), pending = cards.length, shown = false;
        function reveal() { if (!shown) { shown = true; fan.classList.add('is-ready'); } }
        for (var k = 0; k < cards.length; k++) {
          var pick = picks[k], a = cards[k], im = a.querySelector('img');
          a.href = pick.u; a.setAttribute('aria-label', pick.t); im.alt = pick.t;
          im.onload = im.onerror = function () { if (--pending <= 0) reveal(); };
          im.src = pick.i;
        }
        setTimeout(reveal, 1500);
      })
      .catch(function () { fan.remove(); });
  }
  loadFan();

  /* ---------- product rows ---------- */
  function extractCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var list = doc.querySelector('.products-list') || doc.querySelector('#ProductGridContainer');
    return list ? Array.prototype.slice.call(list.querySelectorAll(':scope > .f-column')) : [];
  }
  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(extractCards);
  }
  function buildUrl(base, sort, page, useSection) {
    var u = new URL(base, window.location.origin);
    if (sort) u.searchParams.set('sort_by', sort);
    if (page > 1) u.searchParams.set('page', String(page));
    if (useSection && gridSection) u.searchParams.set('section_id', gridSection);
    return u.toString();
  }
  function renderRow(row, cards) {
    var grid = row.querySelector('[data-pkl-row-grid]');
    var limit = parseInt(row.getAttribute('data-limit'), 10) || 8;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < Math.min(limit, cards.length); i++) {
      var c = cards[i].cloneNode(true);
      /* the collection's quick-view modals reference IDs that only exist on that page */
      var qv = c.querySelectorAll('quick-view-modal');
      for (var q = 0; q < qv.length; q++) qv[q].remove();
      c.classList.add('pkl-home__card-in');
      frag.appendChild(c);
    }
    grid.innerHTML = '';
    grid.appendChild(frag);
    row.classList.add('is-loaded');
  }
  function loadRow(row, attempt) {
    attempt = attempt || 0;
    var mode = row.getAttribute('data-mode');
    var base = row.getAttribute('data-url') || colUrl;
    var sort = row.getAttribute('data-sort') || '';
    var limit = parseInt(row.getAttribute('data-limit'), 10) || 8;
    var inStock = row.getAttribute('data-instock') === 'true';
    var exclude = (row.getAttribute('data-exclude') || '').split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
    var perPage = 12;
    var page = 1;
    function keep(c) {
      if (inStock && c.querySelector('.f-badge--soldout')) return false;
      /* only cards with a real product image (no placeholder / image-less products) */
      var im = c.querySelector('.product-card__image img');
      if (!im || c.querySelector('.placeholder-svg, .placeholder')) return false;
      if (exclude.length) {
        var t = (c.querySelector('.product-card__title') || c).textContent.toLowerCase();
        for (var i = 0; i < exclude.length; i++) if (t.indexOf(exclude[i]) > -1) return false;
      }
      return true;
    }
    if (mode === 'random') {
      var pages = Math.max(1, Math.ceil(colCount / perPage));
      page = 1 + Math.floor(Math.random() * pages);
    }
    var url = buildUrl(base, sort, page, true);
    fetchCards(url)
      .then(function (cards) {
        if (!cards.length && gridSection) return fetchCards(buildUrl(base, sort, page, false)); /* whole page fallback */
        return cards;
      })
      .then(function (cards) {
        cards = cards.filter(keep);
        function merge(a, b) {
          var seen = {}, out = [];
          a.concat(b).forEach(function (c) { var l = c.querySelector('a[href]'); var k = l ? l.getAttribute('href') : Math.random(); if (!seen[k]) { seen[k] = 1; out.push(c); } });
          return out;
        }
        function topUp(list, nextPage, tries) {
          if (list.length >= limit || tries <= 0) return Promise.resolve(list);
          return fetchCards(buildUrl(base, sort, nextPage, true)).then(function (more) {
            more = more.filter(keep);
            var merged = merge(list, more);
            var next = mode === 'random' ? 1 + Math.floor(Math.random() * Math.max(1, Math.ceil(colCount / perPage))) : nextPage + 1;
            return more.length ? topUp(merged, next, tries - 1) : merged;
          });
        }
        var next = mode === 'random' ? 1 + Math.floor(Math.random() * Math.max(1, Math.ceil(colCount / perPage))) : page + 1;
        return topUp(cards, next, 3);
      })
      .then(function (cards) {
        if (mode === 'random') shuffle(cards);
        if (!cards.length) { row.hidden = true; return; }
        renderRow(row, cards);
      })
      .catch(function () { row.hidden = true; });
  }
  var rows = root.querySelectorAll('[data-pkl-row]');
  for (var r = 0; r < rows.length; r++) {
    (function (row) {
      loadRow(row);
      var btn = row.querySelector('[data-pkl-shuffle]');
      if (btn) btn.addEventListener('click', function () { row.classList.remove('is-loaded'); loadRow(row); });
    })(rows[r]);
  }
})();
